// src/screens/useHabits.ts
import React, { useEffect, useState } from "react";
import { firestore } from "../firebase";
import DB_PATH from "../DB_PATH";
import { Habit } from "../../types/Habit";

export default ({ communityId }: { communityId: string }) => {
  const [habits, setHabits] = useState<Habit[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!communityId) {
      return;
    }
    setLoading(true);

    const habitCollection = firestore
      .collection(DB_PATH.HABIT)
      .where("communityId", "==", communityId);

    const unsubscribe = habitCollection.onSnapshot(
      (snapshot) => {
        const habitData: Habit[] = snapshot.docs.map(
          (doc) =>
            ({
              id: doc.id,
              ...doc.data(),
            } as Habit)
        );
        setHabits(habitData);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching habits: ", error);
        setLoading(false);
      }
    );

    // Cleanup function to unsubscribe from the listener when the component unmounts
    return () => unsubscribe();
  }, [communityId]);

  return { habits, loading };
};
